<script setup name="App">
import router from './router';


</script>
<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" :key="$route.fullPath" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" :key="$route.fullPath" v-if="!$route.meta.keepAlive" />
  </router-view>
</template>

<style>
p,h1,h2,h3,h4,h5,h5{
  margin: 0;
  padding: 0;
}

</style>
